'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'plug';
var width = 448;
var height = 512;
var aliases = [128268];
var unicode = 'f1e6';
var svgPathData = ['M64 128l320 0 0 96c0 88.4-71.6 160-160 160S64 312.4 64 224l0-96z', 'M112-32c8.8 0 16 7.2 16 16l0 112 192 0 0-112c0-8.8 7.2-16 16-16s16 7.2 16 16l0 112 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 96c0 100.6-77.4 183.2-176 191.3l0 80.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-80.7C109.4 407.2 32 324.6 32 224l0-96-16 0c-8.8 0-16-7.2-16-16S7.2 96 16 96l80 0 0-112c0-8.8 7.2-16 16-16zM64 128l0 96c0 88.4 71.6 160 160 160s160-71.6 160-160l0-96-320 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;